import { decodeToken } from 'react-jwt'

/**
 * Claims do access token Auth0 usadas na tela Config Compras.
 * Nunca lança: sem token/sessão retorna objeto vazio.
 */
export const getPurchaseConfigTokenClaims = (): Record<string, any> => {
  try {
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE
    const stored = localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
    if (!stored) return {}
    const parsed = JSON.parse(stored)
    const decoded = decodeToken(parsed?.body?.access_token) as any
    return decoded ?? {}
  } catch {
    return {}
  }
}

const getRoles = (claims: Record<string, any>): string[] => {
  const role = claims?.role
  if (Array.isArray(role)) return role.map(String)
  return role ? [String(role)] : []
}

// Perfil que escolhe qualquer comprador no calendário (mesma regra de antes)
export const isPurchaseConfigAdmin = (
  claims: Record<string, any> = getPurchaseConfigTokenClaims()
): boolean => getRoles(claims).includes('Administrador')

// Perfis que podem criar/editar/excluir Alçadas e Tolerâncias.
// Os demais perfis com acesso à tela só visualizam.
// ATENÇÃO: é só controle de interface — a API precisa validar o perfil.
export const PURCHASE_APPROVAL_MANAGER_ROLES = ['Administrador', 'Diretor']

export const canManagePurchaseApprovalRules = (
  claims: Record<string, any> = getPurchaseConfigTokenClaims()
): boolean =>
  getRoles(claims).some(role => PURCHASE_APPROVAL_MANAGER_ROLES.includes(role))
